module.exports = __webpack_public_path__ + "images/pages/for_business/sp/cv_1_a34ccb9e3f4c954e6b9b49df52a34461.jpg";